import { useCardData } from '../internal/CardDataContext';
import FormattedCard from './FormattedCard';
import { useCardContainerContext } from '../internal/CardContainerContext';
import CardContentPlaceholderDiv from './skeletons/CardContentPlaceholderDiv';
import CardContentLoadingComponent from './skeletons/CardContentLoadingComponent';
import { DEFAULT_LOADING_COMPONENT_PROPS } from '../constants/LoadingComponentProps';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CardLoadingState({
  pastDelay,
  CardFormatter
}) {
  const {
    cardData,
    loadingComponentProps = DEFAULT_LOADING_COMPONENT_PROPS
  } = useCardData();
  const {
    DefaultCardFormatter
  } = useCardContainerContext();
  return /*#__PURE__*/_jsx(FormattedCard, {
    cardData: cardData,
    CardFormatter: CardFormatter || DefaultCardFormatter,
    children: pastDelay ? /*#__PURE__*/_jsx(CardContentLoadingComponent, {}) : /*#__PURE__*/_jsx(CardContentPlaceholderDiv, {
      cardId: cardData.definition.cardId,
      loadingComponentProps: loadingComponentProps
    })
  });
}